import React from "react"
import PropTypes from "prop-types"
import { MapWithMarkers } from "components"

const SingleDealerMapBlock = ({ dealerDetails }) =>
  (<MapWithMarkers
    locations={[dealerDetails]}
    activeIndex={0}
    options={{ disableDefaultUI: true }}
    map={{
      center: {
        lat: Number(dealerDetails.lat),
        lng: Number(dealerDetails.lng)
      },
      zoom: 17
    }} />)

SingleDealerMapBlock.propTypes = {
  dealerDetails: PropTypes.object
}

export default SingleDealerMapBlock



// WEBPACK FOOTER //
// ./src/blocks/single-dealer-map/index.jsx